import React from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { MetricCard } from '../components/growth/MetricCard';
import { KPIGauge } from '../components/growth/KPIGauge';
import { PerformanceTrendChart } from '../components/growth/PerformanceTrendChart';
import { LeadSourceBreakup } from '../components/growth/LeadSourceBreakup';
import { LeadTypeOverview } from '../components/growth/LeadTypeOverview';
import { LeadQueryOverview } from '../components/growth/LeadQueryOverview';
export function GrowthConsole() {
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1835">
      <Sidebar data-id="element-1836" />
      <main className="flex-1" data-id="element-1837">
        <Header data-id="element-1838" />
        <div className="px-6 py-6" data-id="element-1839">
          <h1 className="text-2xl font-semibold text-gray-900 mb-6" data-id="element-1840">
            Growth Console
          </h1>

          {/* Top Metrics Cards */}
          <div className="grid grid-cols-5 gap-4 mb-6" data-id="element-1841">
            <MetricCard label="Spend" value="₹11.25M" data-id="element-1842" />
            <MetricCard label="CPC" value="₹21.64" data-id="element-1843" />
            <MetricCard label="CTR" value="0.96%" data-id="element-1844" />
            <MetricCard label="Leads" value="101.85K" data-id="element-1845" />
            <MetricCard label="CPL" value="₹110.43" data-id="element-1846" />
          </div>

          {/* KPI Gauges */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm mb-6" data-id="element-1847">
            <h2 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1848">KPI</h2>
            <div className="grid grid-cols-4 gap-8" data-id="element-1849">
              <KPIGauge label="Call Answered Ratio" percentage={64} value="35261/55253" color="#2563eb" data-id="element-1850" />
              <KPIGauge label="Call Leads with Status" percentage={80} value="59642/74325" color="#2563eb" data-id="element-1851" />
              <KPIGauge label="Call Leads Sync" percentage={39} value="16549/42118" color="#2563eb" data-id="element-1852" />
              <KPIGauge label="Enquiry to Booking Ratio" percentage={1} value="300/40708" color="#ef4444" data-id="element-1853" />
            </div>
          </div>

          {/* Performance Trend Chart */}
          <div className="mb-6" data-id="element-1854">
            <PerformanceTrendChart data-id="element-1855" />
          </div>

          {/* Bottom Row: Lead Source, Lead Type, Lead Query */}
          <div className="grid grid-cols-3 gap-6 mb-6" data-id="element-1856">
            <LeadSourceBreakup data-id="element-1857" />
            <LeadTypeOverview data-id="element-1858" />
            <div className="col-span-1" data-id="element-1859"></div>
          </div>

          {/* Lead Query Overview - Full Width */}
          <LeadQueryOverview data-id="element-1860" />
        </div>
      </main>
    </div>;
}